/** 一次性把 Channel 自有的 Bridge 文档按 raw 打包进来；key 归一化为
 *  "bridge/<slug>/index.md"，供 <DocMarkdown /> 消费。
 *
 * import.meta.glob 是编译时行为，文件内容内联到 bundle 中，运行时不会去查找外部文件。
 */
const RAW = import.meta.glob("./**/index.md", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

export const bridgeDocs: Record<string, string> = Object.fromEntries(
  Object.entries(RAW).map(([k, v]) => [k.replace(/^\.\//, "bridge/"), v]),
);
